<template>
    <div>
        <div class="w-full flex justify-between border-b-gray-500 text-gray-500 tracking-widest">
            <div>
                Country
            </div>
            <div><span class="text-3xl text-yellow-600" v-if="hasUnsavedChanges">•</span></div>
        </div>
        <div v-if="isEditable" class="flex justify-between items-center pl-2">
            <input @change="updateCountry" type="text" v-model="country" class="border p-1 m-1 w-full">
        </div>
        <div class="pl-2" v-else>
            <div class="p-1">
                {{ calculatedCountry }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from 'vue';

const props = defineProps([
    'company',
    'isEditable'
])

const emit = defineEmits(['update-country'])

const calculatedCountry = computed(() => {
    if(props.company) {
        return props.company.country
    } else {
        return null
    }
})

const country = ref(props.company ? props.company.country : null)

watch(calculatedCountry, () => {
    country.value = calculatedCountry.value
})

const hasUnsavedChanges = computed(() => {
    return props.company && props.company.original_country != props.company.country
})

function updateCountry(){
    emit('update-country', country.value)
}


</script>